/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateFeatureFlagMutationRequest,
  UpdateFeatureFlagMutationResponse,
  UpdateFeatureFlagPathParams,
} from "../types/UpdateFeatureFlag.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateFeatureFlagMutationKey = () =>
  [{ url: "/v1/feature-flags/:name" }] as const

export type UpdateFeatureFlagMutationKey = ReturnType<
  typeof updateFeatureFlagMutationKey
>

/**
 * {@link /v1/feature-flags/:name}
 */
export async function updateFeatureFlag(
  name: UpdateFeatureFlagPathParams["name"],
  data: UpdateFeatureFlagMutationRequest,
  config: Partial<RequestConfig<UpdateFeatureFlagMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateFeatureFlagMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateFeatureFlagMutationRequest
  >({
    method: "PUT",
    url: `/v1/feature-flags/${name}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateFeatureFlagMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateFeatureFlagMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateFeatureFlagMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateFeatureFlagMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      name: UpdateFeatureFlagPathParams["name"]
      data: UpdateFeatureFlagMutationRequest
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ name, data }) => {
      return updateFeatureFlag(name, data, config)
    },
  })
}

/**
 * {@link /v1/feature-flags/:name}
 */
export function useUpdateFeatureFlag<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateFeatureFlagMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        name: UpdateFeatureFlagPathParams["name"]
        data: UpdateFeatureFlagMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateFeatureFlagMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateFeatureFlagMutationKey()

  const baseOptions = updateFeatureFlagMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateFeatureFlagMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      name: UpdateFeatureFlagPathParams["name"]
      data: UpdateFeatureFlagMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateFeatureFlagMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      name: UpdateFeatureFlagPathParams["name"]
      data: UpdateFeatureFlagMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateFeatureFlagMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      name: UpdateFeatureFlagPathParams["name"]
      data: UpdateFeatureFlagMutationRequest
    },
    TContext
  >
}
